import React from 'react';
import Home from '../components/home/Home';
import About from '../components/about/About';
import Space from '../components/space/Space';
import '../styles/pagestyles/home.css';

const Main = () => {
  return (
    <div>
      <div id='/'>
        <Home/>
      </div>
      <div id='about' className='give-more-space'>
        <About/>
      </div>
      <div>
        <Space/>
      </div>
    </div>
    
  );
};
  
export default Main;